<template>
	<div class="container page">
		<van-nav-bar :title="$t('setting.bank_info')" class="nav-bar">
			<template #left>
				<van-icon name="arrow-left" color="#fff" @click="back()" />
			</template>
		</van-nav-bar>
		<div class="wrapper">
			<div class="add-card" @click="$router.push({path: '/BindCard'})" v-if="!bank.id">
				<van-icon name="plus" />
				<span>{{$t("setting.add_bank")}}</span>
			</div>
			<div class="bank" v-else>
				<div class="info">
					<div class="row-content">{{bank.real_name}}</div>
					<div class="row-content">{{bank.bank_name}}</div>
					<div class="row-content">{{bank.account}}</div>
				</div>
			</div>
			<div class="tips">{{$t("setting.bind_bank_tip")}}</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				bank: {
					id: '',
					info: '',
					username: "",
					bankid: ""
				},
			};
		},
		created() {
			this.getUserInfo();
		},
		methods: {
			back() {
				return window.history.back();
			},
			getUserInfo() {
				this.$http({
					method: 'get',
					url: 'user_info'
				}).then(res => {
					if (res.code == 1) {
						console.log(res.data, '4789761456')
						this.bank = res.data.bankinfo
					} else {
						this.$toast(res.msg);
					}
				})
			},

		},

	};
</script>

<style lang='less' scoped>
	@import "../../assets/css/base.css";

	.nav-bar {
		background: linear-gradient(90deg, #f905e5, #e6c3a1);
	}

	.van-cell {
		font-size: 35px;
		line-height: 80px;
	}

	.container p {
		padding: 0 15px;
		margin-top: 15px;
		font-size: 30px;
		color: #dc2037;
	}

	.manage-card .wrapper {
		height: calc(100% - 10px);
		overflow-y: auto;
		-webkit-overflow-scrolling: touch;
	}

	.wrapper .add-card {
		display: flex;
		align-items: center;
		justify-content: center;
		color: #000;
		background-color: #fff;
		height: 250px;
	}

	.wrapper .add-card span {
		margin-left: 10px;
		font-size: 30px;
	}

	.wrapper .tips {
		margin: 15px 15px;
		font-size: 25px;
		color: #979799;
	}

	.wrapper .bank .info {
		margin-left: 20px;
		flex: 1;
		color: #000;
	}

	.wrapper .bank .info .row-content {
		margin: 30px 0;
		line-height: 20px;
		font-size: 30px;
	}
</style>